import GridSelectionLimitControl from "./GridSelectionLimitControl";

import { Button } from "@/components/ui/button";

interface GridSelectionSelectAllMatchingProps {
  totalMatching: number;
  limitInput: string;
  onSelectAllMatching: () => void;
  onLimitChange: (value: string) => void;
  onLimitBlur: () => void;
}

const GridSelectionSelectAllMatching = ({
  totalMatching,
  limitInput,
  onSelectAllMatching,
  onLimitChange,
  onLimitBlur,
}: GridSelectionSelectAllMatchingProps) => (
  <div className="inline-flex items-center">
    <Button
      variant="ghost"
      size="sm"
      className="rounded-r-none border border-slate-200 bg-white text-slate-700 shadow-sm shadow-slate-200/60 hover:border-slate-300 hover:bg-slate-50 hover:text-slate-900"
      onClick={onSelectAllMatching}
    >
      Select all {totalMatching.toLocaleString()}
    </Button>
    <GridSelectionLimitControl
      totalMatching={totalMatching}
      value={limitInput}
      showSelectAllMatching
      onChange={onLimitChange}
      onBlur={onLimitBlur}
    />
  </div>
);

export default GridSelectionSelectAllMatching;
